import { render, staticRenderFns } from "./DeductionDrawer.vue?vue&type=template&id=2c534367"
import script from "./DeductionDrawer.vue?vue&type=script&lang=js"
export * from "./DeductionDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports